export default __webpack_public_path__ + "static/media/priority_icon.480a1cbe.svg";